import OrderItemDetailsMenu from './OrderItemDetailsMenu';

export default OrderItemDetailsMenu;
